import React from 'react';
import PrimarySectionLayout from '../layout/PrimarySectionLayout'
import PrimaryButton from '../common/PrimaryButton';
import ResultCard from '../common/pagecomponents/ResultCard'
import { graphql, useStaticQuery } from 'gatsby';
import AniLink from "gatsby-plugin-transition-link/AniLink"

const BandResult = () => {
    
    const data = useStaticQuery(query);

    const { allStrapiHomeBandResult: { nodes: HomeBandResult } } = data;

    const { allStrapiResult: { nodes: HomeBandResultCards } } = data;

    const { home_bandresult_heading, home_bandresult_subheading, home_bandresult_button } = HomeBandResult[0];

    return (
        <>
            <PrimarySectionLayout PrimarySectionHeading={home_bandresult_heading} PrimarySectionSubheading={home_bandresult_subheading}>
                <div className="band_result_card_container">
                    <div
                        className="band_result_card_wrapper"
                        id="band_result_card_wrapper_first"
                    >
                        {HomeBandResultCards.map((resultCard) => (
                            <ResultCard
                                key={resultCard.Result_Card.id}
                                ResultCardName={resultCard.Result_Card.result_name}
                                ResultCardDescription={resultCard.Result_Card.result_description}
                                ResultCardImgUrl={resultCard.Result_Card.result_image[0].url}
                            />
                        ))}
                    </div>
                    <div
                        className="band_result_card_wrapper"
                        id="band_result_card_wrapper_second"
                    >
                        {HomeBandResultCards.map((resultCard) => (
                            <ResultCard
                                key={resultCard.Result_Card.id}
                                ResultCardName={resultCard.Result_Card.result_name}
                                ResultCardDescription={resultCard.Result_Card.result_description}
                                ResultCardImgUrl={resultCard.Result_Card.result_image[0].url}
                            />
                        ))}
                    </div>
                </div>
                <AniLink fade to={home_bandresult_button.button_redirection}>
                    <PrimaryButton ButtonText={home_bandresult_button.button_text} MaxWidth={13.9375} />
                </AniLink>
            </PrimarySectionLayout>
        </>
    );
};

export const query = graphql`
{
  allStrapiHomeBandResult {
    nodes {
      home_bandresult_heading
      home_bandresult_subheading
      home_bandresult_button {
        button_text
        button_redirection
      }
    }
  }
  allStrapiResult(filter: {Result_Card: {published_homepage: {eq: true}}}) {
    nodes {
      Result_Card {
        id
        result_name
        result_description
        result_image {
          url
        }
      }
    }
  }
}
`;

export default BandResult;
